import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';

import Input from 'src/componentes/input';
import AvatarUsuario from 'src/paginas/colaborador/componentes/avatar-usuario';
import OnboardingHeader from '../OnboardingHeader';
import OnboardingFooter from '../OnboardingFooter';

const BasicDataStep = ({
  onNext,
  onBack,
  meusDados,
  currentStep,
  totalSteps,
}) => {
  const intl = useIntl();

  const usuarioId = meusDados?.id;
  const [nome, setNome] = useState(meusDados?.nome || '');
  const [email, setEmail] = useState(meusDados?.email || '');
  const [celular, setCelular] = useState(meusDados?.celular || '');
  const [fotoArquivo, setFotoArquivo] = useState(meusDados?.fotoArquivo);
  const [podeAlterar] = useState(meusDados?.podeAlterar);
  const [ehUsuarioAdmin] = useState(meusDados?.ehUsuarioAdmin);

  useEffect(() => {
    if (!meusDados) return;

    setNome(meusDados.nome || '');
    setEmail(meusDados.email || '');
    setCelular(meusDados.celular || '');
    setFotoArquivo(meusDados.fotoArquivo);
  }, [meusDados]);

  const handleContinue = () => {
    const dadosAtualizados = { };

    if (nome !== meusDados.nome) dadosAtualizados.nome = nome;
    if (email !== meusDados.email) dadosAtualizados.email = email;
    if (celular !== meusDados.celular) dadosAtualizados.celular = celular;
    if (fotoArquivo !== meusDados.fotoArquivo)
      dadosAtualizados.fotoArquivo = fotoArquivo;

    onNext(dadosAtualizados, { validarAgora: true });
  };

  const renderContent = () => (
    <>
      <h4 style={{ marginBottom: 4 }}>
        <strong>{intl.formatMessage({ id: 'dadosBasicos' })}</strong>
      </h4>

      <p style={{ color: '#6c757d', marginBottom: 32 }}>
        {intl.formatMessage({ id: 'completeSeusDados' })}
      </p>

      <div
        style={{
          marginBottom: 24,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <div style={{ width: 100 }}>
          <AvatarUsuario
            usuarioId={usuarioId}
            model={{ value: fotoArquivo, requestChange: setFotoArquivo }}
            label={intl.formatMessage({ id: 'nome' })}
          />
        </div>
      </div>

      <div style={{ textAlign: 'left' }}>
        <div>
          <strong>{intl.formatMessage({ id: 'nome' })}</strong>
        </div>
        <Input
          label={intl.formatMessage({ id: 'nome' })}
          model={{ value: nome, requestChange: setNome }}
          placeholder={nome ? nome : intl.formatMessage({ id: 'placeholderNome' })}
          disabled={!podeAlterar}
        />
        <div>
          <strong>{intl.formatMessage({ id: 'email' })}</strong>
        </div>
        <Input
          label={intl.formatMessage({ id: 'email' })}
          model={{ value: email, requestChange: setEmail }}
          placeholder={email ? email : intl.formatMessage({ id: 'placeholderEmail' })}
          disabled={!podeAlterar && !ehUsuarioAdmin}
        />
        <div>
          <strong>{intl.formatMessage({ id: 'celular' })}</strong>
        </div>
        <Input
          label={intl.formatMessage({ id: 'celular' })}
          model={{ value: celular, requestChange: setCelular }}
          disabled={!podeAlterar}
        />
      </div>
    </>
  );

  return (
    <div
      style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}
    >
      <OnboardingHeader currentStep={currentStep} totalSteps={totalSteps} />

      <div
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div style={{ width: '60%', maxWidth: 600 }}>{renderContent()}</div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: '60%', maxWidth: 600 }}>
          <OnboardingFooter onBack={onBack} onPrimaryAction={handleContinue} />
        </div>
      </div>
    </div>
  );
};

export default BasicDataStep;
